import { render, staticRenderFns } from "./MaterialImageCarousel.vue?vue&type=template&id=437d58c7&scoped=true"
import script from "./MaterialImageCarousel.vue?vue&type=script&lang=ts"
export * from "./MaterialImageCarousel.vue?vue&type=script&lang=ts"
import style0 from "./MaterialImageCarousel.vue?vue&type=style&index=0&id=437d58c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437d58c7",
  null
  
)

export default component.exports